<script>
    import { onMount } from 'svelte';
    import { navigate } from 'svelte-routing';
    import { env, principalStreamersNames } from '../../Environment.svelte';
    import Button from '../Button.svelte';
    import { boxProperties } from '../../data/boxProperties';
    import { store } from '../../Store.svelte';

    export let plan;
    export let category;
    export let home = false;
    export let productObject;

    const { title, nombreCode, cost, itemInstalacion, precioInstalacion } =
        plan;
    const planProperties = boxProperties
        .find((box) => box.category === category)
        .details.find((plan) => plan.nombreCode === nombreCode);
    const { promotion, features } = planProperties;

    onMount(() => {
        $store.requestedServices.product = null;
    });

    function addPlanStore() {
        $store.requestedServices.izzimovil = [];

        if (
            $store.requestedAddress.postalCode != null &&
            $store.requestedAddress.postalCode.length > 0 &&
            !home
        ) {
            $store.requestedServices.channelExtras = [];
            $store.requestedServices.productId = plan.paqId;
            plan['productFamily'] = category;
            $store.requestedServices.product = plan;
            $store.requestedServices.tvExtensionsExtras = [];
            $store.requestedServices.phoneExtras = [];
            $store.requestedServices.phoneExtensionsExtras = [];
            $store.purchaseStatus = env.cleanstore.purchaseStatus;
            $store.requestedServices.isVix =
                plan.extrasMap.ott.length > 0 &&
                plan.extrasMap.ott.filter(
                    (ott) => ott.extra.extName === principalStreamersNames[0]
                ).length > 0;

            window.scrollTo(0, 0);
            if (home) {
                window.parent.location =
                    env[env.stage].urlweb + '/compra/configura';
            } else {
                window.top.location.href =
                    env[env.stage].urlweb + '/compra/configura';
                navigate('/compra/configura', { replace: false });
                location.reload();
            }
        } else {
            if (productObject != null) {
                productObject.productFamily = category;
                productObject.productId = plan.paqId;
                productObject.productSpeed = plan.vel;
            }
            $store.requestedServices.productObject.productFamily = category;
            $store.requestedServices.productObject.productId = plan.paqId;
            $store.requestedServices.productObject.productSpeed = plan.vel;
            MicroModal.show('modal-cobertura');
        }
    }
</script>

<div class="plan-container-sky">
    <div class="plan-title {!promotion ? 'expanded' : ''}">
        <p>{title}</p>
    </div>
    {#if promotion}
        <div class="plan-promo">
            <p>{@html promotion}</p>
        </div>
    {/if}
    <div class="plan-cost">
        <p>${cost}<span>/mes</span></p>
    </div>
    <div class="plan-type-sky-features-container">
        <ul>
            {#each features as feature}
                <li class="m-t-5">{@html feature}</li>
            {/each}
        </ul>
    </div>
    <div class="plan-button">
        <Button
            label="Seleccionar"
            process="Seleccionar"
            variant="pure__button--blue-dark"
            onClick={addPlanStore}
        />
    </div>
    <div class="plan-footer">
        <!-- <p>{itemInstalacion} ${precioInstalacion}</p> -->
    </div>
</div>
